import { render } from "./UserControl.vue?vue&type=template&id=518a9ef3"
import script from "./UserControl.vue?vue&type=script&lang=js"
export * from "./UserControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__